import React from 'react'
import cx from 'classnames'
import {Icon} from 'common/Icon'
import styles from './Heart.scss'

export const Heart = ({liked, count, onClick}) => (
  <div className={styles.Heart} onClick={onClick}>
    <Icon
      className={cx(styles.heartIcon, liked && styles.liked)}
      i={liked ? 'md-heart' : 'md-heart-outline'} size={24}
      title={liked ? 'unlike report' : 'like report'} />
    {count && count > 0
      ? <div className={styles.count}>{count}</div>
      : <a className={styles.likeText}>like{liked && 'd'}</a>
    }
  </div>
)

// we are going to make the Heart not float to the left, and once we do that
// this can be removed.
export const HeartClickTarget = ({onClick}) => (
  <div className={cx(styles.Heart, styles.HeartClickTarget)} onClick={onClick} />
)
